import React from 'react';

class MapLegend extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.items || []
        };
    }
    render() {
        let data = this.props.data || [];
        if (data.length > 0) {
            return (
                <div>
                    {data.map(function (item, key) {
                        if (item.type === "wms" && item.checked) {
                            let legendImage = item.url + "?LAYER=" + item.layerName + "&VERSION=1.1.1&SERVICE=WMS&REQUEST=GetLegendGraphic&FORMAT=image/png&TRANSPARENT=true";
                            return (
                                <div key={key}>
                                    <p>
                                        <span>Capa:</span>{" "}
                                        <span className="text-primary">{item.label}</span>
                                        {"  "}
                                        <a
                                            href={item.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <i className="fas fa-download"></i>
                                        </a></p>
                                    <img src={legendImage}/>
                                </div>
                            )
                        }
                    })}
                </div>
            )
        } else {
            return <div></div>;
        }
    }
}

export default MapLegend;